import React from 'react'
import "./Education.css"
import { NavLink } from 'react-router-dom'

const educationlist = [
    "Cutting-edge technical education - in computer science, coding, and IT to K-12 students across the nation.",
    "Free access to high-quality learning resources- designed to equip students with critical digital skills for the future.",
    "Collaborative workshops and training programs- tailored to all age groups, from young students to higher education learners.",
    "Mentorship and hands-on/ Online- learning opportunities through ICOESS’s expertise in web development and technical training."
]

const Education = () => {
    return (
        <>
            <div className='Education-div'>
                <h2>
                    <span>ICOESS Solutions</span> Partners with <span>EPIC</span> to Revolutionize Technical Education
                </h2>
                <p>We are thrilled to announce our collaboration with EPIC – the Technical Education Outreach Program Council of India, an initiative committed to empowering young minds with essential tech skills. This partnership aims to bridge the digital divide by providing cutting-edge education in computer science, coding, and IT to K-12 students across the nation. By combining ICOESS's expertise in web development and technical training with EPIC’s outreach program, we are poised to create a holistic learning experience that is accessible, practical, and free of cost. Together, we aim to foster a generation of tech-savvy students, equipped with the tools they need to thrive in an increasingly digital world. Stay tuned for a range of exciting workshops, resources, and collaborative opportunities that will shape the future of technical education for students of all ages!</p>
                <div className='Education-underdiv'>
                    <div className='underdiv Education-div-underdiv2'>
                        <img src="assets/EducationSupport/partner.jpg" alt="Partnership-With-Epic" />
                    </div>
                    <div className='underdiv Education-div-underdiv1'>
                        <dl>
                            <dt>This partnership aims to deliver:</dt>
                            <dl>
                                <ul>
                                    {educationlist.map((e) => (
                                        <li>{e}</li>
                                    ))}
                                </ul>
                            </dl>
                        </dl>
                        <div className='partnership'>
                            <NavLink target='_blank' to="http://epicorg.in">
                                <p>To know more about EPIC Program click here...</p>
                            </NavLink>
                            <NavLink className={"ctabutton"} target='_blank' to="http://epicorg.in">
                                EPIC Program
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Education
